// removed by extract-text-webpack-plugin
module.exports = {"table":"_326df0d990_src-comparableSales-_AllTabsSummary_table","root":"_0d99788604_src-comparableSales-_AllTabsSummary_root","leftTable":"c919ace6b8_src-comparableSales-_AllTabsSummary_leftTable","rightTable":"_50b410a1bf_src-comparableSales-_AllTabsSummary_rightTable"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/AllTabsSummary.css
// module id = 1066
// module chunks = 0